import React from 'react';
import { BrowserRouter, renderRoutes } from 'mage-react-router';

import App from '@/pages/headhunters';
import Job from '@/pages/headhunters/[orgId]/job/[jobId]';
import Organization from '@/pages/headhunters/[orgId]/org';
import ExcelResult from '@/pages/headhunters/[orgId]/recommend/[jobId]/excel_result';
import RecommendResult from '@/pages/headhunters/[orgId]/recommend/[jobId]/result';
import UpdateResult from '@/pages/headhunters/[orgId]/update/[applicationId]/result';
import ApplicationList from '@/pages/headhunters/[orgId]/org/applications';
import JobList from '@/pages/headhunters/[orgId]/org/jobs';
import ResultCandidateInfo from '@/pages/headhunters/[orgId]/recommend/[jobId]';
import UpdateCandidateInfo from '@/pages/headhunters/[orgId]/update/[applicationId]';
import ExcelApplicationList from '@/pages/headhunters/[orgId]/org/excel_applications';

// 增加路由需要修改 src\initial\clientEnv.js 的 orgId 获取正则，不然会有灰度问题
const routes = [
  {
    path: ['/headhunters/:orgId', '/headhunters'],
    component: App,
    routes: [
      {
        path: '/org',
        component: Organization,
        routes: [
          {
            path: '/jobs',
            exact: true,
            component: JobList,
          },
          {
            path: '/applications',
            exact: true,
            component: ApplicationList,
          },
          {
            path: '/excel_applications',
            exact: true,
            component: ExcelApplicationList,
          },
        ],
      },
      {
        path: '/job/:jobId/:contractId',
        exact: true,
        component: Job,
      },
      {
        path: '/recommend/:jobId/:contractId',
        component: ResultCandidateInfo,
        routes: [
          {
            path: '/result',
            exact: true,
            component: RecommendResult,
          },
          {
            path: '/excel_result',
            exact: true,
            component: ExcelResult,
          },
        ],
      },
      {
        path: '/update/:applicationId',
        component: UpdateCandidateInfo,
        routes: [
          {
            path: '/result',
            exact: true,
            component: UpdateResult,
          },
        ],
      },
    ],
  },
];

const Routes = () => <BrowserRouter>{renderRoutes(routes)}</BrowserRouter>;
export default Routes;
